import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearch } from '@tanstack/react-router';
import { useAuthenticatedFetch } from '../../hooks/useAuth';

export const CreateFolderPage: React.FC = () => {
  const navigate = useNavigate();
  const search = useSearch({ from: '/f/new' });
  const authenticatedFetch = useAuthenticatedFetch();
  const hasStartedRef = useRef(false);

  useEffect(() => {
    if (hasStartedRef.current) {
      return;
    }
    hasStartedRef.current = true;

    const createFolder = async () => {
      const name = (search as any).name || 'New Folder';
      
      try {
        const response = await authenticatedFetch(`/api/folders/new?name=${encodeURIComponent(name)}`);
        
        if (response.ok) {
          const data = await response.json();
          navigate({ to: data.redirect });
        } else {
          console.error('Failed to create folder');
          navigate({ to: '/' });
        }
      } catch (error) {
        console.error('Error creating folder:', error);
        navigate({ to: '/' });
      }
    };
    
    createFolder();
  }, [navigate, search, authenticatedFetch]);
  
  return (
    <div className="flex items-center justify-center h-screen">
      <div className="text-center">
        <div className="text-lg">Creating folder...</div>
      </div>
    </div>
  );
};